//import { BreadContext } from "../../utils/context/breadcrum";
import Icon from "../../Icons/general/Icon";

function NoPermission() {
  //const { setRuta } = BreadContext();
  
  return (
    <div className="flex max-w-full h-screen items-center justify-center">
    <div className="flex flex-row h-[14rem] w-[32rem] border border-red-300 text-red-600 px-8 py-6 rounded-2xl shadow-lg text-center items-center justify-center bg-gray-100">
      <div className="flex">
        <div>
           <Icon
              svg="blocked"
              className="w-[9rem] h-[9rem] fill-red-500"
              title="pencil"
            />
        </div>
        <div className="flex flex-col text-center items-center justify-center" >
              <span className="font-medium text-xl">No esta autorizado para utilizar esta opción.</span>
              <span className="text-base text-red-900 mt-8">Consulte con el administrador de la aplicación por la autorización.</span>
           </div>
        </div>
     
    </div>  
    </div>
  );
}
export default NoPermission;
